import React from 'react';

import { Box, Tooltip } from '@mui/material';

import TagLabel from '../../components/TagLabel';
import { DLXDriveTagType } from '../../@types/dlx-drive/types';

// ----------------------------------------------------------------------

type DLXDriveTagProps = {
  tag: DLXDriveTagType;
};

const DLXDriveTag: React.FC<DLXDriveTagProps> = ({ tag }) => {
  const { id, name, color } = tag;

  return (
    // Move the id attribute here (Box supports HTML id)
    <Box
      id={id.toString()}
      component="span"
      sx={{
        display: 'inline-block',
      }}
    >
      <TagLabel color={color}>
        <Tooltip title={name}>
          <Box
            component="span"
            sx={{
              overflow: 'hidden',
              lineHeight: 'initial',
            }}
          >
            {name}
          </Box>
        </Tooltip>
      </TagLabel>
    </Box>
  );
};

export default DLXDriveTag;
